import { LocalStorageKeys } from "@repo/logic";
import { ms } from "humanize-ms";

const inactivityTime = ms("30m");
const warningTime = ms("2m");

export enum inactivityStatus {
    active = "active",
    warning = "warning",
    inactive = "inactive",
}

export enum channelMessages {
    logout = "LOGOUT",
    closeWarning = "CLOSE_WARNING",
    openWarning = "OPEN_WARNING",
}

const getActivity = (): number | undefined => {
    const activity = localStorage.getItem(LocalStorageKeys.LAST_ACTIVITY);
    if (activity) return parseInt(activity);
    else return undefined;
};

export const checkActivity = (): inactivityStatus | null => {
    const current = new Date().getTime();
    const last = getActivity();
    if (last && current - last < inactivityTime) {
        return inactivityStatus.active;
    } else if (last && current - last < inactivityTime + warningTime) {
        return inactivityStatus.warning;
    } else if (last) {
        return inactivityStatus.inactive;
    }
    return null;
};

export const setActivity = (): void => {
    const date = new Date().getTime();
    localStorage.setItem(LocalStorageKeys.LAST_ACTIVITY, date.toString());
};
